import { InputHTMLAttributes, ReactNode, Ref, useId } from 'react';

import { Styles, css, cx } from '@flipster/styled-system/css';
import { checkedInput } from '@flipster/styled-system/recipes';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'title' | 'type' | 'className'> {
  ref?: Ref<HTMLInputElement>;
  children?: ReactNode;
  css?: Styles;
}

export const RadioButton = ({ ref, children, css: cssProps, ...inputRef }: Props) => {
  const labelId = useId();
  const classes = checkedInput();

  return (
    <label data-disabled={inputRef.disabled} className={cx(classes.control, css(cssProps))}>
      <input type='radio' {...inputRef} ref={ref} className={classes.input} />
      <div className={classes.action_wrapper}>
        <span role='radio' aria-checked={inputRef.checked} aria-labelledby={labelId} className={classes.radio} />
        <wbr />
      </div>
      <span id={labelId} className={classes.label}>
        {children}
      </span>
    </label>
  );
};
